import { Box, BoxProps } from '@chakra-ui/react'
import * as React from 'react'

import { PageType } from '../../context/LayoutContext'
import { TextNav } from '../common/Text'
import Link from '../common/Link'

export type NavPCLinkProps = BoxProps & {
  to: PageType
  localizeKey: string
}

const NavPCLink: React.FC<NavPCLinkProps> = ({ to, localizeKey, ...others }) => {
  return (
    <>
      <Box position="relative" {...others}>
        <Link to={to}>
          <TextNav
            localizeKey={localizeKey}
            lineHeight="1"
            _before={{
              position: 'absolute',
              top: '50%',
              left: '-80px',
              width: '30px',
              height: '1px',
              content: '""',
              backgroundColor: 'white',
              transition: 'all 0.25s cubic-bezier(0.23, 1, 0.32, 1)',
            }}
            _hover={{
              '&:before': {
                width: '60px',
              },
            }}
          />
        </Link>
      </Box>
    </>
  )
}

export default NavPCLink
